module.exports = __webpack_public_path__ + "static/media/bg44.6e8fa9e2.jpg";